import { Component, OnInit, TemplateRef } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { UserService } from "../../../../services/userService/user.service";
import { environment } from "../../../../../environments/environment";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { ToastrService } from "ngx-toastr";
import { Router, ActivatedRoute } from "@angular/router";
import { RolePermissionServiceService } from "../../../../services/rolepermission/role-permission-service.service";
import { RolePermissionService } from "../../../../appService/role-permission.service";
import { HttpClient } from "@angular/common/http";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: "app-orderattachment",
  templateUrl: "./orderattachment.component.html",
  styleUrls: ["./orderattachment.component.css"],
})
export class OrderattachmentComponent implements OnInit {
  orderdoc: any;
  active: string;
  permission: any;
  url: string;
  dft_icn: string;
  downloadurl: string;
  userid: any;
  btnLoader: boolean = false;
  id: any;
  isMediabtnClicked: boolean;
  mediaUploadDisplay: boolean;
  totalMediaSize: any;
  totalMediaLength: number;
  modalRef: BsModalRef;
  config: {
    class: "modal-dialog-centered";
    backdrop: "static";
    ignoreBackdropClick: true;
    keyboard: false;
  };
  upload_disable: boolean;
  preview: string;
  fileUpload: any[];
  imgURL: any[];
  mediaPostTextTemp: string;
  mediaPostLoader: boolean;
  mediaPostArr: {};
  allowDragover: boolean;
  postTextWithLink: string;
  sharePostArr: {};
  urlMediaTitle: any;
  urlTitle: any;
  urlMediaDescription: any;
  urlDescription: any;
  urlMediaImage: any;
  urlImage: any;
  urlMediaLink: any;
  urlLink: any;
  iframe: any;
  isPrivacySettingsMediaPostBtnEnable: boolean;
  fileUploadCount: number;
  postMediaGreaterThanCheckError: string;
  file_upload_loader: boolean;
  videoURL: any[];
  isImagePasted: boolean;
  pasteEvnetStatus: boolean;
  fileUploadLoader: boolean;
  clicked: boolean;
  filename: any;
  file: any;
  delNameDel: boolean;
  isCollapsed: boolean;
  type: any;
  base64Image1: string;
  fileId: any;
  OnedriveForm: FormGroup;
  oneDriveLink: any;
  roleId: any;
  submitted = false;
  proposalUrlStatus: boolean = false;
  DocTypeId: any = 0;

  constructor(
    private route: ActivatedRoute,
    private UserService: UserService,
    private service: RolePermissionService,
    private roleservice: RolePermissionServiceService,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private http: HttpClient,
    private formBuilder: FormBuilder
  ) {
    this.active = localStorage.getItem("active_id");
    let decid = localStorage.getItem("editOid");
    decid = decid.toString().replace("Ar1t", "=").replace("FGH", "/").replace("THD", "+");
    this.id = this.UserService.decryptData(decid);
    let permi = JSON.parse(localStorage.getItem("Permission"));
    this.permission = this.UserService.decryptData(permi);
  }

  ngOnInit(): void {
    this.url = environment.tempimage;
    this.downloadurl = environment.orderDownloadPath;
    this.dft_icn = environment.default_temp;
    let rId = localStorage.getItem("roleId");
    this.roleId = this.UserService.decryptData(rId);
    this.getOrderDetails();

    this.OnedriveForm = this.formBuilder.group({
      DriveId: ["", [Validators.maxLength(250), Validators.pattern(/^((ftp|http|https):\/\/)?[a-zA-Z0-9\-\.]+\.[a-zA-Z]{2,63}(\/[\w\-\.~:@?%&+\/#=]*)?$/)]],
    });
  }

  getOrderDetails() {
    let data = {
      OrderInfoId: this.id,
      Mode: "Edit",
    };
    this.spinner.show();
    this.UserService.GetOrderReviewDetailById(data).subscribe(
      (res) => {
        if (res["result"] == "Success") {
          this.spinner.hide();
          this.orderdoc = res["UploadDocument"];
          this.oneDriveLink = res["UploadDocument"][15].UrlPath;
        } else if (res["result"] == "Failed") {
          this.toastr.error(res["Msg"]);
          this.spinner.hide();
          this.router.navigate(["/profile"]);
        } else {
          this.toastr.error(res["Msg"]);
          this.spinner.hide();
        }
      },
      (err) => {
        this.spinner.hide();
        if (err && (err.Msg || err.Message)) {
          this.toastr.error(err.Msg || err.Message);
        }
      }
    );
  }

  openModal(template: TemplateRef<any>, type: any, TypeId: any) {
    this.DocTypeId = TypeId;
    this.type = type;
    this.isMediabtnClicked = false;
    this.mediaUploadDisplay = true;
    this.totalMediaSize = 0;
    this.totalMediaLength = 0;
    this.modalRef = this.modalService.show(template, {
      class: "modal-dialog-centered",
      backdrop: "static",
      ignoreBackdropClick: true,
      keyboard: false,
    });
    this.upload_disable = true;
    this.preview = "";
    this.fileUpload = [];
    this.imgURL = [];
    this.mediaPostTextTemp = "";
    this.mediaPostLoader = true;
    this.mediaPostArr = {};
    this.allowDragover = false;
    this.postTextWithLink = "";
    this.sharePostArr = {};
    this.urlMediaTitle = this.urlTitle;
    this.urlMediaDescription = this.urlDescription;
    this.urlMediaImage = this.urlImage;
    this.urlMediaLink = this.urlLink;
    this.urlMediaImage = this.iframe;
    this.isPrivacySettingsMediaPostBtnEnable = false;
    this.urlTitle = "";
    this.urlDescription = "";
    this.urlImage = "";
    this.urlLink = "";
    this.iframe = "";
    this.fileUploadCount = 0;
    this.postMediaGreaterThanCheckError = "";
  }

  closeModalFileUplaodFalse() {
    this.file_upload_loader = false;
    this.imgURL = [];
    this.videoURL = [];
    this.fileUpload = [];
    this.isImagePasted = false;
    this.pasteEvnetStatus = true;
    this.fileUploadCount = 0;
  }

  fileChangeEvent(event: any) {
    let file_array = [];
    let upload_fileIcon = environment.upload_image_url;
    this.allowDragover = false;
    if (event && event.target && event.target.files) {
      file_array = event.target.files;
      this.totalMediaLength += file_array.length;
      if (this.totalMediaLength <= 1) {
        let x = 0;

        while (x < file_array.length) {
          let fileDetails = file_array[x];

          this.totalMediaSize += fileDetails.size;
          if (this.totalMediaSize <= 36700160) {
            if (
              fileDetails.type == "image/png" ||
              fileDetails.type == "image/jpeg" ||
              fileDetails.type == "image/webp" ||
              fileDetails.type == "image/gif" ||
              fileDetails.type == "image/x-icon" ||
              fileDetails.type == "image/bmp"
            ) {
              this.file_upload_loader = true;
              let $this_func = this;
              let getCustomerSyncFlag = function (callback) {
                $this_func.setupReader(fileDetails, x, file_array.length);
                let SyncFlag = x + 1;
                callback(null, SyncFlag);
              };

              getCustomerSyncFlag(function (err, SyncFlag) {
                x = SyncFlag;
              });
            } else if (
              fileDetails.type == "video/mp4" ||
              fileDetails.type == "video/webm" ||
              fileDetails.type == "video/ogg" ||
              fileDetails.type == "video/quicktime"
            ) {
              this.file_upload_loader = true;
              let $this_func = this;
              let getCustomerSyncFlag = function (callback) {
                $this_func.setupReader(fileDetails, x, file_array.length);
                let SyncFlag = x + 1;
                callback(null, SyncFlag);
              };

              getCustomerSyncFlag(function (err, SyncFlag) {
                x = SyncFlag;
              });
            } else if (
              fileDetails.type == "audio/ogg" ||
              fileDetails.type == "audio/mpeg" ||
              fileDetails.type == "audio/vnd.dlna.adts"
            ) {
              this.file_upload_loader = true;
              let $this_func = this;
              let getCustomerSyncFlag = function (callback) {
                if (fileDetails.type.includes("audio/")) {
                  switch (fileDetails.type) {
                    case "audio/ogg":
                      $this_func.imgURL.push({
                        url: upload_fileIcon + "file_icons/ogg.png",
                        size: fileDetails.size,
                        type: "image",
                        name: fileDetails.name,
                      });
                      break;

                    case "audio/mpeg":
                      $this_func.imgURL.push({
                        url: upload_fileIcon + "file_icons/mp3.png",
                        size: fileDetails.size,
                        type: "image",
                        name: fileDetails.name,
                      });
                      break;

                    case "audio/vnd.dlna.adts":
                      $this_func.imgURL.push({
                        url: upload_fileIcon + "file_icons/aac.png",
                        size: fileDetails.size,
                        type: "image",
                        name: fileDetails.name,
                      });
                      break;

                    default:
                      $this_func.imgURL.push({
                        url: upload_fileIcon + "format/audio.webp",
                        size: fileDetails.size,
                        type: "image",
                        name: fileDetails.name,
                      });
                      break;
                  }
                }
                $this_func.fileUpload.push(fileDetails);
                $this_func.fileUploadCount = $this_func.fileUpload.length;
                let SyncFlag = x + 1;
                callback(null, SyncFlag);
              };

              getCustomerSyncFlag(function (err, SyncFlag) {
                x = SyncFlag;
                if (x == file_array.length) {
                  $this_func.file_upload_loader = false;
                }
              });
            } else if (
              fileDetails.type == "application/vnd.ms-excel" ||
              fileDetails.type == "application/msword" ||
              fileDetails.type ==
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
              fileDetails.type ==
              "application/vnd.oasis.opendocument.spreadsheet" ||
              fileDetails.type ==
              "application/vnd.oasis.opendocument.spreadsheet" ||
              fileDetails.type == "application/pdf" ||
              fileDetails.type == "text/csv" ||
              fileDetails.type == "message/rfc822" ||
              fileDetails.type ==
              "application/vnd.ms-powerpointapplication/vnd.ms-powerpoint" ||
              fileDetails.type === "application/vnd.ms-powerpoint" ||
              fileDetails.type ===
              "application/vnd.openxmlformats-officedocument.presentationml.presentation" ||
              fileDetails.type ==
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
              fileDetails.type ==
              "application/vnd.ms-word.document.macroEnabled.12" ||
              fileDetails.type == "text/plain" ||
              fileDetails.type == "application/vnd.ms-powerpoint" ||
              fileDetails.type == "application/zip" ||
              fileDetails.type == "application/octet-stream" ||
              fileDetails.type == "application/x-zip-compressed" ||
              fileDetails.type == "multipart/x-zip" ||
              fileDetails.type == "application/vnd.rar" ||
              fileDetails.type == "application/x-rar-compressed" ||
              (fileDetails.type == "" && fileDetails.name.slice(-4) == ".rar")
            ) {
              this.file_upload_loader = true;
              let $this_func = this;
              let getCustomerSyncFlag = function (callback) {
                switch (fileDetails.type) {
                  case "application/vnd.ms-excel":
                    $this_func.imgURL.push({
                      url: upload_fileIcon + "file_icons/csv.png",
                      size: fileDetails.size,
                      type: "image",
                      name: fileDetails.name,
                    });
                    break;

                  case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                    $this_func.imgURL.push({
                      url: upload_fileIcon + "file_icons/excel.png",
                      size: fileDetails.size,
                      type: "image",
                      name: fileDetails.name,
                    });
                    break;

                  case "application/vnd.oasis.opendocument.spreadsheet":
                    $this_func.imgURL.push({
                      url: upload_fileIcon + "file_icons/excel.png",
                      size: fileDetails.size,
                      type: "image",
                      name: fileDetails.name,
                    });
                    break;

                  case "application/pdf":
                    $this_func.imgURL.push({
                      url: upload_fileIcon + "file_icons/pdf.png",
                      size: fileDetails.size,
                      type: "image",
                      name: fileDetails.name,
                    });
                    break;

                  case "application/vnd.ms-powerpointapplication/vnd.ms-powerpoint":
                    $this_func.imgURL.push({
                      url: upload_fileIcon + "file_icons/ppt.png",
                      size: fileDetails.size,
                      type: "image",
                      name: fileDetails.name,
                    });
                    break;

                  case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                    $this_func.imgURL.push({
                      url: upload_fileIcon + "file_icons/word.png",
                      size: fileDetails.size,
                      type: "image",
                      name: fileDetails.name,
                    });
                    break;

                  case "application/msword":
                    $this_func.imgURL.push({
                      url: upload_fileIcon + "file_icons/word.png",
                      size: fileDetails.size,
                      type: "image",
                      name: fileDetails.name,
                    });
                    break;

                  case "application/vnd.ms-word.document.macroEnabled.12":
                    $this_func.imgURL.push({
                      url: upload_fileIcon + "file_icons/word.png",
                      size: fileDetails.size,
                      type: "image",
                      name: fileDetails.name,
                    });
                    break;

                  case "text/plain":
                    $this_func.imgURL.push({
                      url: upload_fileIcon + "file_icons/txt.png",
                      size: fileDetails.size,
                      type: "image",
                      name: fileDetails.name,
                    });
                    break;

                  case "application/vnd.ms-powerpoint":
                    $this_func.imgURL.push({
                      url: upload_fileIcon + "file_icons/ppt.png",
                      size: fileDetails.size,
                      type: "image",
                      name: fileDetails.name,
                    });
                    break;

                  default:
                    $this_func.imgURL.push({
                      url: upload_fileIcon + "file_icons/file.png",
                      size: fileDetails.size,
                      type: "image",
                      name: fileDetails.name,
                    });
                    break;
                }
                $this_func.fileUpload.push(fileDetails);
                $this_func.fileUploadCount = $this_func.fileUpload.length;
                let SyncFlag = x + 1;
                callback(null, SyncFlag);
              };

              getCustomerSyncFlag(function (err, SyncFlag) {
                x = SyncFlag;
                if (x == file_array.length) {
                  $this_func.file_upload_loader = false;
                }
              });
            } else {
              this.totalMediaSize -= fileDetails.size;
              this.totalMediaLength = this.totalMediaLength - 1;
              if (x + 1 == file_array.length) {
                this.file_upload_loader = false;
              }
              if (fileDetails.type.includes("image/")) {
                this.toastr.error(
                  "Images can't be uploaded. Only jpg, jpeg, png, webp, ico, bmp and gif files are allowed!",
                  "Error!"
                );
              } else if (fileDetails.type.includes("video/")) {
                this.toastr.error(
                  "Video can't be uploaded. Only MP4, Mov webm and ogg files are allowed!",
                  "Error!"
                );
              } else if (fileDetails.type.includes("audio/")) {
                this.toastr.error(
                  "Audio can't be uploaded. Only mp3, aac and ogg files are allowed!",
                  "Error!"
                );
              } else if (
                fileDetails.type.includes("application/") ||
                fileDetails.type.includes("text/")
              ) {
                this.toastr.error(
                  "File can't be uploaded. Only CSV,XLS,XLSX,DOC,DOCX,DOCM,PDF,TXT,PPT,ZIP files are allowed!",
                  "Error!"
                );
              } else if (fileDetails.type == "" || fileDetails.type == null) {
                this.toastr.error("File can't supported", "Error!");
              } else {
                this.toastr.error(
                  "File can't be uploaded. Only Image, Audio, Video and Doc files are allowed!",
                  "Error!"
                );
              }
              x++;
            }
          } else {
            this.totalMediaSize -= fileDetails.size;
            this.toastr.error(
              "File can't be uploaded. Total File size should be smaller than 35 MB.",
              "Error!"
            );
            if (x + 1 == file_array.length) {
              this.file_upload_loader = false;
            }
            this.totalMediaLength = 0;
            x++;
          }
        }
      } else {
        this.totalMediaLength -= file_array.length;
        this.toastr.error(
          "Unable to upload more than 1 file at a time.",
          "Error!"
        );
      }
    } else {
      this.toastr.error(
        "File can't be uploaded. Only Image, Audio, Video and Doc files are allowed!",
        "Error!"
      );
    }
  }

  RemoveImage(data, key) {
    this.totalMediaSize = +this.totalMediaSize - +data.size;
    this.totalMediaLength = this.totalMediaLength - 1;
    this.pasteEvnetStatus = true;
    this.imgURL.splice(key, 1);
    this.fileUpload.splice(key, 1);
    this.fileUploadCount = 0;
    this.file_upload_loader = false;
    this.postMediaGreaterThanCheckError = "";
    this.allowDragover = false;
  }

  setupReader(file, num, file_length) {
    let upload_fileIcon = environment.upload_image_url;
    try {
      let fileReader = new FileReader();
      let $this = this;
      if (file.type.match("image")) {
        if (file.size < "20971520") {
          fileReader.onload = function () {
            $this.imgURL.push({
              url: fileReader.result,
              size: file.size,
              type: "image",
              name: file.name,
            });
            $this.fileUpload.push(file);
            $this.fileUploadCount = $this.fileUpload.length;
            if (num + 1 == file_length) {
              $this.file_upload_loader = false;
            }
            $this.pasteEvnetStatus = true;
          };
          fileReader.readAsDataURL(file);
        } else {
          $this.imgURL.push({
            url: upload_fileIcon + "image_preview.jpg",
            size: file.size,
            type: "image",
            name: file.name,
          });
          $this.fileUpload.push(file);
          $this.fileUploadCount = $this.fileUpload.length;

          if (num + 1 == file_length) {
            $this.file_upload_loader = false;
          }
          $this.pasteEvnetStatus = true;
        }
      }
    } catch (error) {
      this.imgURL.push({
        url: upload_fileIcon + "no_preview.jpg",
        size: file.size,
        type: "image",
        name: file.name,
      });
      this.fileUpload.push(file);
      this.fileUploadCount = this.fileUpload.length;

      if (num + 1 == file_length) {
        this.file_upload_loader = false;
      }
      this.pasteEvnetStatus = true;
    }
  }

  orderReviewid = this.route.snapshot.params["id"];

  addMediaPost(type, DocTypeId) {
    this.submitted = true;
    this.btnLoader = true;
    this.totalMediaSize = 0;
    this.totalMediaLength = 0;
    this.fileUploadLoader = true;
    this.imgURL = [];
    this.videoURL = [];
    let frmData = new FormData();
    frmData.append("OrderInfoId", this.id);
    if (type == "Onedrive Link") {
      if (this.OnedriveForm.get("DriveId").value.trim() == "") {
        this.toastr.error("Please enter a valid url first");
        return false;
      }
      frmData.append("TypeId", DocTypeId);
      frmData.append("OnedriveLink", this.OnedriveForm.value.DriveId);
    } else {
      for (const file of this.fileUpload) {
        frmData.append("file[]", file);
        frmData.append("TypeId", DocTypeId);
      }
      // switch (type) {
      //   case "Inquiry Document":
      //     frmData.append("TypeId", "1");
      //     break;
      //   case "Final Quotation":
      //     frmData.append("TypeId", "2");
      //     break;
      //   case "Technical Data Sheet":
      //     frmData.append("TypeId", "3");
      //     break;
      //   case "Compliance Statement":
      //     frmData.append("TypeId", "4");
      //     break;
      //   case "Consultant Approval Sheet":
      //     frmData.append("TypeId", "5");
      //     break;
      //   case "Consultant Comments & Responses":
      //     frmData.append("TypeId", "6");
      //     break;
      //   case "GA Drawings":
      //     frmData.append("TypeId", "7");
      //     break;
      //   case "Client SO / AGR":
      //     frmData.append("TypeId", "8");
      //     break;
      //   case "SO Acknowledgement":
      //     frmData.append("TypeId", "9");
      //     break;
      //   case "Costing Sheet":
      //     frmData.append("TypeId", "10");
      //     break;
      //   case "Factory Price and Delivery Confirmation":
      //     frmData.append("TypeId", "11");
      //     break;
      //   case "Factory Technical Confirmation Emails":
      //     frmData.append("TypeId", "12");
      //     break;
      //   case "Others 1":
      //     frmData.append("TypeId", "13");
      //     break;
      //   case "Others 2":
      //     frmData.append("TypeId", "14");
      //     break;
      //   case "Others 3":
      //     frmData.append("TypeId", "15");
      //     break;
      //   default:
      //     break;
      // }
    }
    if (this.OnedriveForm.valid) {
      this.UserService.UploadOrderDocument(frmData).subscribe(
        (res) => {
          this.fileUploadLoader = false;
          if (res && res["result"] && res["result"] == "success") {
            this.toastr.success(res["Msg"], "Success!");
            this.fileUploadCount = 0;
            this.fileUploadLoader = false;
            this.fileUpload = [];
            this.btnLoader = false;
            this.closeModalFileUplaodFalse();
            this.getOrderDetails();
            if (frmData.get("TypeId") != "16") {
              this.modalRef.hide();
            }
          } else {
            this.fileUploadCount = 0;
            this.fileUploadLoader = false;
            this.fileUpload = [];
            this.closeModalFileUplaodFalse();
            this.toastr.error(res["Msg"], "Error!");
            this.btnLoader = false;
            this.getOrderDetails();
            if (frmData.get("TypeId") != "16") {
              this.modalRef.hide();
            }
            this.spinner.hide();
          }
        },
        (err) => {
          this.fileUploadCount = 0;
          this.fileUploadLoader = false;
          this.fileUpload = [];
          this.btnLoader = false;
          this.closeModalFileUplaodFalse();
          this.spinner.hide();
          if (
            err &&
            err["error"] &&
            err["error"]["result"] == "failed" &&
            err["error"]["Msg"]
          ) {
            this.toastr.error(err["error"]["Msg"], "Error!");
            localStorage.removeItem("token");
            this.router.navigate([
              "/orderReview/editproductreview/" + this.orderReviewid,
            ]);
          } else {
            if (err && err["Msg"]) {
              this.toastr.error(
                "File not uploaded. You may have slow internet speed or uploaded media size is too large.",
                "Error!"
              );
            }
          }
        }
      );
    }
    this.submitted = false;
    this.clicked = false;
  }

  NameSpaceNotAllowed(event: any) {
    let RegEx = /^([a-zA-Z\d!@#$&().,%*=|~[\]{}<>?'";:-])*$/g;
    let str = event.target.value;
    if (RegEx.test(str)) {
      return event.target.value;
    } else {
      let nameString = str.replace(/\s+/g, " ");
      nameString = nameString.replace(
        /[^a-zA-Z\d!@#$&()\-`.+,%*-=|~[\]{}/<>'";:]+/g,
        " "
      );
      event.target.value = nameString.replace(/^\s+/g, "");
    }
  }

  deleteOpenModal(template: TemplateRef<any>, name, id, data) {
    if (data) {
      this.filename = name;
      this.file = data[name];
      this.fileId = id;
      this.modalRef = this.modalService.show(template, {
        class: "modal-sm modal-dialog-centered",
      });
    }
  }

  deleteConfirm() {
    this.deletefileinfo();
    this.modalRef.hide();
  }

  deletefileinfo() {
    this.spinner.show();
    this.delNameDel = true;
    let Data = {
      OrderInfoId: this.id,
      FileId: this.fileId,
    };
    this.UserService.RemoveOrderDocument(Data).subscribe(
      (res) => {
        this.delNameDel = false;
        if (res && res["result"] == "success") {
          this.spinner.hide();
          this.getOrderDetails();
          this.toastr.success(res["Msg"], "Success!");
          this.modalRef.hide();
        }
      },
      (err) => {
        this.delNameDel = false;
        if (err && (err.Msg || err.Message || err.message)) {
          this.toastr.error(err.Msg || err.Message || err.message);
        }
      }
    );
  }

  downloadModal(template: TemplateRef<any>, name, data) {
    if (data) {
      this.filename = name;
      this.file = data;
      this.modalRef = this.modalService.show(template, {
        class: "modal-sm modal-dialog-centered",
      });
    }
  }

  downloadConfirm() {
    this.download();
    this.modalRef.hide();
  }

  decline() {
    this.modalRef.hide();
  }

  download(): any {
    window.open(this.file);
  }

  openClosefun() {
    this.isCollapsed = !this.isCollapsed;
  }
}
